// all Languages to choose
export enum enumAvailableLanguages {
  german = "de-DE",
  english = "en-US",
  spanish = "es-ES",
  french = "fr-FR",
  italian = "it-IT",
  swedish = "sv-SE",
}

export enum channelMethode {
  bundle = "bundle", // no itx
  name = "name", // no itx
  native = "native", // no itx
  notSet = "",
}

export enum PrefixMode {
  DIN = 0,
  DOT = 1,
}

/** Identifies the application shell currently using the shared ESTADA state. */
export enum ApplicationMode {
  Main = "main",
  ConceptOne = "c1",
}
